module.exports = __webpack_public_path__ + "img/SKWINKELNetActieSuggestiesE2A637.fe95d769.png";